import * as requester from '../utils/requester';

export const createCafeDiscountRequest = reqObject => {
  return new Promise((resolve, reject) => {
    return requester
      .fetchAPI({
        method: 'POST',
        route: 'v1/cafe-discount',
        data: reqObject
      })
      .then(res => {
        resolve(res.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const getMyCafeDiscountsList = query => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/cafe-discount?${query}`,
        method: 'GET'
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const fetchAllCafeDiscountRequests = query => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/cafe-discount/requested?${query}`,
        method: 'GET'
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const fetchAllCafeDiscountRequestArchives = query => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/cafe-discount/archived?${query}`,
        method: 'GET'
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const fetchCafeDiscountRequestDetailsById = id => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/cafe-discount/${id}`,
        method: 'GET'
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const updateCafeDiscountRequestStatus = (id, status, rejectionReason) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/cafe-discount/${status == 'approve' ? 'confirm' : 'reject'}`,
        method: 'PUT',
        data: {
          id,
          rejectionReason
        },
        withAuth: true
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};
